var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAddFilled = function SvgAddFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2A14.172 14.172 0 0 0 2 16a14.172 14.172 0 0 0 14 14 14.172 14.172 0 0 0 14-14A14.172 14.172 0 0 0 16 2Zm8 15h-7v7h-2v-7H8v-2h7V8h2v7h7v2Z",
    fill: "#333"
  })));
};

export { SvgAddFilled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2IDJDMTIuMzAwOCAyLjA0NDYzIDguNzY1NzUgMy41MzM5NSA2LjE0OTg1IDYuMTQ5ODVDMy41MzM5NSA4Ljc2NTc1IDIuMDQ0NjMgMTIuMzAwOCAyIDE2QzIuMDQ0NjMgMTkuNjk5MiAzLjUzMzk1IDIzLjIzNDMgNi4xNDk4NSAyNS44NTAxQzguNzY1NzUgMjguNDY2IDEyLjMwMDggMjkuOTU1NCAxNiAzMEMxOS42OTkyIDI5Ljk1NTQgMjMuMjM0MyAyOC40NjYgMjUuODUwMSAyNS44NTAxQzI4LjQ2NiAyMy4yMzQzIDI5Ljk1NTQgMTkuNjk5MiAzMCAxNkMyOS45NTU0IDEyLjMwMDggMjguNDY2IDguNzY1NzUgMjUuODUwMSA2LjE0OTg1QzIzLjIzNDMgMy41MzM5NSAxOS42OTkyIDIuMDQ0NjMgMTYgMlpNMjQgMTdIMTdWMjRIMTVWMTdIOFYxNUgxNVY4SDE3VjE1SDI0VjE3WiIgZmlsbD0iIzMzMzMzMyIvPgo8L3N2Zz4K";